import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  {{avatar this.item imageSize="tiny"}}

<span class="username">{{format-username this.item.username}}</span>

{{#if this.item.name}}
  <span class="name">{{this.item.name}}</span>
{{/if}}
*/
{
  "id": "f85k8tTu",
  "block": "[[[1,[28,[35,0],[[30,0,[\"item\"]]],[[\"imageSize\"],[\"tiny\"]]]],[1,\"\\n\\n\"],[10,1],[14,0,\"username\"],[12],[1,[28,[35,1],[[30,0,[\"item\",\"username\"]]],null]],[13],[1,\"\\n\\n\"],[41,[30,0,[\"item\",\"name\"]],[[[1,\"  \"],[10,1],[14,0,\"name\"],[12],[1,[30,0,[\"item\",\"name\"]]],[13],[1,\"\\n\"]],[]],null]],[],false,[\"avatar\",\"format-username\",\"if\"]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-packages/select-kit.dd9a86fe/node_modules/select-kit/components/user-chooser/user-row.hbs",
  "isStrictMode": false
});